/** Session-pinned celebration ids revitalized this browser session (Home list UX). */

const STORAGE_KEY = "lembra:returned_to_schedule_v1";
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

type Entry = { id: string; at: number };

function readEntries(): Entry[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (e): e is Entry =>
        typeof e === "object" &&
        e != null &&
        typeof (e as Entry).id === "string" &&
        typeof (e as Entry).at === "number",
    );
  } catch {
    return [];
  }
}

export function pinReturnedToSchedule(celebrationId: string): void {
  const now = Date.now();
  const next = [
    { id: celebrationId, at: now },
    ...readEntries().filter((e) => e.id !== celebrationId),
  ].slice(0, 20);
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* quota — best effort */
  }
}

export function getReturnedToScheduleIds(): string[] {
  const cutoff = Date.now() - MAX_AGE_MS;
  return readEntries()
    .filter((e) => e.at >= cutoff)
    .map((e) => e.id);
}

export function clearReturnedToSchedule(celebrationId: string): void {
  const next = readEntries().filter((e) => e.id !== celebrationId);
  try {
    if (next.length === 0) sessionStorage.removeItem(STORAGE_KEY);
    else sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
}
